import sales_icon from 'assets/images/sales_icon.png';
import attendance from 'assets/images/attendance.png';
import shipping from 'assets/images/shipping.png';
import profile from 'assets/images/profile.png';
import samplecheck from 'assets/images/samplecheck.png';
import inventory from 'assets/images/inventory.png';
import ledgerCurrentYear from 'assets/images/ledgercurrentyear.png';
import ledgerdivisionwise from 'assets/images/ledgerdivisionwise.png';
import stockDownloadImage from 'assets/images/stock_download.png';
import productAssessmentImage from 'assets/images/product_assessment.png';
import assessmentReport from 'assets/images/assessment_reports.png';
import vendorLeadger from 'assets/images/Ledger.png';
import ptFile from 'assets/images/ptFIle.png';
import BeatManagement from 'assets/images/BeatManagement.png';
import marketIntelligence from 'assets/images/marketIntelligence.png';
import ProductCatalogue from 'assets/images/product_catlogue.png';
import goodsReturn from 'assets/images/GoodsReturn.png';
import pendindorderreports from 'assets/images/pendingorderreport.png';
import paymentreceived from 'assets/images/paymentreceived.png';
import outstandingreport from 'assets/images/outstandingreport.png';
import outstanding1 from 'assets/images/outstanding1.png';
import home from 'assets/images/house.png';
import sampleRequest from 'assets/images/sampleRequest.png';
import salesplanning from 'assets/images/salesplanning.png';
import kpi from 'assets/images/kpi.png';
import scheme from 'assets/images/scheme.png';
import collachiv from 'assets/images/collachiv.png';
import dashboard from 'assets/images/dashboard.png';

const baseMenuList = [
  /* ================= EXPLORE ================= */
  {
    title: 'Explore',
    subItems: [
      { name: 'Dashboard', nav: '/report-dashboard', image: home },
      { name: 'Classic Console', nav: '/dashboard', image: dashboard },
      { name: 'Sales Order', nav: '/salesorder', image: sales_icon },
      { name: 'My Orders', nav: '/myordersreport', image: shipping },
    ]
  },

  /* ================= ACTIVITIES ================= */
  {
    title: 'Activities',
    subItems: [
      { name: 'Customer Profile', nav: '/customerProfile', image: profile },
      { name: 'Sample Check', nav: '/samplecheck', image: samplecheck },
      { name: 'Stock Upload', nav: '/stockupload', image: inventory },
      { name: 'Sales Order Upload', nav: '/salesOrderUpload', image: sales_icon },
      { name: 'Product Assessment', nav: '/passessment', image: productAssessmentImage },
      { name: 'BEATS', nav: '/beats', image: BeatManagement },
      { name: 'Market Intelligence', nav: '/market-intelligence', image: marketIntelligence },
      { name: 'Product Catalogue', nav: '/product-catalogue', image: ProductCatalogue },
      { name: 'Sample Request', nav: '/sample-request-dashboard', image: sampleRequest },
      { name: 'Sales Planning', nav: '/dashboard-sales-planning', image: salesplanning },
      { name: 'Good Returns', nav: '/good-returns-list', image: goodsReturn }
    ]
  },

  /* ================= LEDGER ================= */
  {
    title: 'Ledger',
    subItems: [
      { name: 'Ledger Current Year', nav: '/ledgerCurrentYear', image: ledgerCurrentYear },
      { name: 'Ledger Previous Year', nav: '/ledgerpreviousYear', image: ledgerCurrentYear },
      { name: 'Vendor Ledger', nav: '/vendorLedger', image: vendorLeadger },
      { name: 'Division Wise Ledger', nav: '/ledgerDiv', image: ledgerdivisionwise }
    ]
  },

  /* ================= OUTSTANDING ================= */
  {
    title: 'Outstanding',
    subItems: [
      { name: 'Outstanding', nav: '/divoutstanding', image: outstanding1 },
      { name: 'Division Outstanding', nav: '/divoutstandingnew', image: outstanding1 }
    ]
  },

  /* ================= REPORTS ================= */
  {
    title: 'Reports',
    subItems: [
      { name: 'My Attendance', nav: '/attedancereport', image: attendance },
      { name: 'Assessment Reports', nav: '/assessment-reports', image: assessmentReport },
      { name: 'KPI Report', nav: '/distributorkpi-reports', image: kpi },
      { name: 'Pending Order Reports', nav: '/pending-order-reports', image: pendindorderreports },
      { name: 'Outstanding Reports', nav: '/outstanding-reports', image: outstandingreport },
      { name: 'Payment Received', nav: '/collection-recieved', image: paymentreceived },
      // { name: 'Scheme Report', nav: '/scheme-report', image: scheme },
      { name: 'Collection Target vs Achivemnet (Received)', nav: '/collection-target-achv-report', image: collachiv },
      { name: 'Current Months Sales Figure', nav: '/current-month-sales-report', image: collachiv }
    ]
  },

  /* ================= DOWNLOADS ================= */
  {
    title: 'Downloads',
    subItems: [
      
      { name: 'Download', nav: '/stockdownload', image: stockDownloadImage },
      { name: 'PT File', nav: '/ptFile', image: ptFile }
    ]
  }
];

const primHiddenItems = new Set([
  'Customer Profile',
  'Stock Upload',
  'Product Assessment',
  'BEATS',
  'Market Intelligence',
  'Sample Request',
  'Sales Planning',
  'Good Returns',
  'My Attendance',
  'Assessment Reports'
]);

export const getMenuListByUserType = (userType = '', userCode = '') => {
  const isPrimUser = String(userType || '').toUpperCase() === 'PRIM';
  const canAccessGoodReturns = String(userCode || '') === '272101';
  const menuWithGoodReturnsAccess = baseMenuList.map((section) => ({
    ...section,
    subItems: section.subItems.filter(
      (item) => item.name !== 'Good Returns' || canAccessGoodReturns
    )
  }));

  if (isPrimUser) return menuWithGoodReturnsAccess;

  return menuWithGoodReturnsAccess.map((section) => ({
    ...section,
    subItems: section.subItems.filter((item) => !primHiddenItems.has(item.name))
  }));
};

const detectedUserType = (() => {
  try {
    if (typeof window === 'undefined') return '';
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user?.userTypeId || '';
  } catch {
    return '';
  }
})();

const detectedUserCode = (() => {
  try {
    if (typeof window === 'undefined') return '';
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user?.userCode || '';
  } catch {
    return '';
  }
})();

export const menulist = getMenuListByUserType(detectedUserType, detectedUserCode);
